var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtn)?_c('span',{staticClass:"text-warning"},[_c('i',{staticClass:"fa fa-exclamation-circle fa-lg icon-button mr-1",attrs:{"title":"Justificativas da reprovação"},on:{"click":function($event){$event.stopPropagation();return _vm.mostrarJustificativa()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }